import revive_payload_client_4sVQNw7RlN from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/opt/build/repo/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/opt/build/repo/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/opt/build/repo/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_Ug908EZNww from "/opt/build/repo/node_modules/nuxt-site-config/dist/runtime/app/plugins/i18n.js";
import plugin_client_LcKgStRyi6 from "/opt/build/repo/node_modules/nuxt-gtag/dist/runtime/plugin.client.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "/opt/build/repo/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/opt/build/repo/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import sanity_image_builder_bQsAocKPDm from "/opt/build/repo/plugins/sanity-image-builder.js";
import populated_input_CRPVJvABrd from "/opt/build/repo/plugins/populated-input.js";
import toggle_nav_oP4qjcII7O from "/opt/build/repo/plugins/toggle-nav.js";
import vue_easy_lightbox_client_lWqeizDQUL from "/opt/build/repo/plugins/vue-easy-lightbox.client.ts";
import get_safe_localized_field_KuZgOgAJmO from "/opt/build/repo/plugins/get-safe-localized-field.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  i18n_Ug908EZNww,
  plugin_client_LcKgStRyi6,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  sanity_image_builder_bQsAocKPDm,
  populated_input_CRPVJvABrd,
  toggle_nav_oP4qjcII7O,
  vue_easy_lightbox_client_lWqeizDQUL,
  get_safe_localized_field_KuZgOgAJmO
]